module.exports = __webpack_public_path__ + "media/components/src/assets/images/embedded_parts/youtube-8c5e36ebb40c4217f1473e4404f8c36d.jpg";